@if (showOverlay == true) {
  <div class="modal-backdrop fade show"></div>
}

<div class="d-flex flex-row">
  <div class="flex-grow-1 d-flex flex-column main-column">
    <app-header></app-header>

    <app-banner></app-banner>

    <div class="d-sm-flex container main-container h-100 flex-grow-1">
      <main role="main">
        <router-outlet></router-outlet>
        <app-toast-container></app-toast-container>
      </main>
    </div>

    <app-scroll-to-top-button></app-scroll-to-top-button>

    <footer class="custom-footer">
      <app-footer></app-footer>
    </footer>
  </div>
  @if (mediaBreakpoint >= emediaBreakpoint.XXL) {
    <app-sidebar-cart></app-sidebar-cart>
  }
</div>

<app-sidebar-user></app-sidebar-user>

@if (mediaBreakpoint < emediaBreakpoint.LG) {
  <app-sticky-footer-mobile></app-sticky-footer-mobile>
}

@if (mediaBreakpoint < emediaBreakpoint.XXL) {
  @if (shouldDisplaySidebarShoppingCart) {
    <app-cart-offcanvas-preview></app-cart-offcanvas-preview>
  }
}
